import { Box } from "@mui/material";
import React from "react";

const ListWrap = ({ children }) => {
  return (
    <Box
      sx={{
        margin: "0px 1rem",
        display: "flex",
        flexDirection: "column",
        minHeight: "calc(100vh - 100px)", // Ensure it takes up enough space
        height: "auto",
        overflow: "visible",
        pb: 2,
      }}
    >
      {children}
    </Box>
  );
};

export default ListWrap;
